import classNames from "classnames";
import React, { useCallback, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { IconMessage } from "../../../components/icons/icon-message";
import { IconWhatsapp } from "../../../components/icons/icon-whatsapp";

interface ChooseAuthMethodProps {
  phoneNumber: string;
  onSubmit: (method: "wa" | "sms", recaptchaToken: string) => void;
}

export const ChooseAuthMethod: React.FunctionComponent<ChooseAuthMethodProps> = ({ phoneNumber, onSubmit }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  const handleSubmitMethod = useCallback(async (method: "wa" | "sms") => {
    if (!executeRecaptcha) return;
    setSubmitting(true);
    const recaptchaToken = await executeRecaptcha("request_otp_web_buyer");
    setSubmitting(false);
    onSubmit(method, recaptchaToken);
  }, [executeRecaptcha, onSubmit]);

  return (
    <div className="bg-gray-100 flex flex-col px-4 h-screen justify-center">
      <h1 className="text-primary text-xl">Pilih Metode Di Bawah</h1>
      <p className="py-4">
        Pilih salah satu metode dibawah untuk mendapatkan kode 6 digit
      </p>
      <div
        className="flex flex-col items-center pt-8"
        id="auth-method-item"
        data-testid="auth-method-item"
      >
        <div onClick={() => { handleSubmitMethod("wa") }}
          className={classNames(
            "rounded-lg flex flex-row p-4 shadow items-center w-full mb-4",
            {
              "bg-white hover:bg-gray-50 cursor-pointer": !isSubmitting,
              "cursor-not-allowed": isSubmitting,
            }
          )}
          id="auth-wa-btn"
          data-testid="auth-wa-btn"
        >
          <IconWhatsapp className="text-green size-6" />
          <div className="ml-4">
            <p className="font-bold pb-1">WhatsApp ke nomor</p>
            <p>+62{phoneNumber}</p>
          </div>
        </div>
        <div onClick={() => { handleSubmitMethod("sms") }}
          className={classNames(
            "rounded-lg flex flex-row p-4 shadow items-center w-full",
            {
              "bg-white hover:bg-gray-50 cursor-pointer": !isSubmitting,
              "cursor-not-allowed": isSubmitting,
            }
          )}
          id="auth-sms-btn"
          data-testid="auth-sms-btn"
        >
          <IconMessage className="text-primary size-6" />
          <div className="ml-4">
            <p className="font-bold pb-1">SMS ke nomor</p>
            <p>+62{phoneNumber}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
